import React, { useEffect, useState, useRef } from "react";
import { Link } from "react-router-dom";
import Collapse from "react-bootstrap/Collapse";
import RepairPoServices from "../../../services/RepairPoServices";


import Swal from "sweetalert2";
import POMakingModal from './POMakingModal';
import Select from 'react-select';
import { Spinner } from 'react-bootstrap';
import { utils, writeFile } from "xlsx"; // ✅ Import XLSX methods

const PoPendingList = () => {
  const [open, setOpen] = useState(false);
  const [open2, setOpen2] = useState(true);
  const [gridInsideModal, setGridInsideModal] = useState(false);
  const [sort, setSort] = useState(40);
  const activePag = useRef(0);
  const [searchTerm, setSearchTerm] = useState('');
  const [pendingPOs, setPendingPOs] = useState([]);
  const [activePage, setActivePag] = useState(0);
  const [test, setTest] = useState(0);
  const [selectedItem, setSelectedItem] = useState();
  const [loading, setLoading] = useState(true);


  useEffect(() => {
    const fetchPendingPOs = async () => {
      try {
        setLoading(true); // Start loader
        const response = await RepairPoServices.pendingPoList();
        const poList = response?.data || [];
        setPendingPOs(poList);
      } catch (error) {
        Swal.fire("Error", "Failed to fetch pending POs", "error");
      } finally {
        setLoading(false); // End loader
      }
    };

    fetchPendingPOs();
  }, [test]);

  const filteredSearch = pendingPOs.filter((row) => {
    const search = searchTerm.toLowerCase();

    const repairOrderNo =
      row?.repairOrderNo?.toString().toLowerCase() || "";

    const storeName =
      row?.store?.toLowerCase() || "";

    const partNos =
      row?.items
        ?.map(i => i?.inventory?.masterItem?.partNo?.toString().toLowerCase())
        .join(" ") || "";

    const descriptions =
      row?.items
        ?.map(i => i?.inventory?.masterItem?.description?.toLowerCase())
        .join(" ") || "";

    return (
      repairOrderNo.includes(search) ||
      storeName.includes(search)
    );
  });


  const options = [
    { value: 5, label: '5' },
    { value: 10, label: '10' },
    { value: 20, label: '20' },
    { value: 50, label: '50' },
    { value: 100, label: '100' }
  ];

  useEffect(() => {
    if (pendingPOs.length > 0) {
      setActivePag(0);
    }
  }, [pendingPOs]);

  const pagination = Math.ceil(filteredSearch.length / sort);

  const onClick = (i) => {
    activePag.current = i;
    setTest(i);
  };

  const handleViewClick = (item) => {
    setSelectedItem(item);
    setGridInsideModal(true);
  };

  // ✅ Download Excel function
 const handleDownloadExcel = () => {
  if (filteredSearch.length === 0) {
    Swal.fire("No Data", "No pending Repair Orders found!", "info");
    return;
  }

  const workbook = utils.book_new();
  const excelData = [];

  filteredSearch.forEach((row, roIndex) => {
    if (row?.items?.length > 0) {
      row.items.forEach((item, itemIndex) => {
        excelData.push({
          "S.No": roIndex + 1,
          "Repair Order No": row?.repairOrderNo || "N/A",
          "Store": row?.store || "N/A",

          "Created Date": row?.createdAt
            ? new Date(row.createdAt).toLocaleDateString("en-IN")
            : "N/A",

          "Approved Date": row?.updatedAt
            ? new Date(row.updatedAt).toLocaleDateString("en-IN")
            : "N/A",

          "Item No": itemIndex + 1,

          // ✅ FIXED PATH HERE
          "Repair Part No":
            item?.masterlist?.partNo || "N/A",

          "Repair Description":
            item?.masterlist?.description || "N/A",

          "Qty Required": item?.qtyRequired || 0,
          "Approved Qty": item?.approveQty || 0,
        });
      });
    } else {
      excelData.push({
        "S.No": roIndex + 1,
        "Repair Order No": row?.repairOrderNo || "N/A",
        "Store": row?.store || "N/A",
        "Created Date": "N/A",
        "Approved Date": "N/A",
        "Item No": "-",
        "Repair Part No": "-",
        "Repair Description": "-",
        "Qty Required": "-",
        "Approved Qty": "-",
      });
    }
  });

  const sheet = utils.json_to_sheet(excelData);
  utils.book_append_sheet(workbook, sheet, "Pending Repair Orders");

  writeFile(workbook, "Pending_Repair_Orders.xlsx");

  Swal.fire("Success", "Repair Pending Orders Excel downloaded", "success");
};



  return (
    loading ? (
      <div className="d-flex flex-column align-items-center justify-content-center" style={{ minHeight: '200px' }}>
        <Spinner animation="border" variant="primary" role="status" />
        <p className="mt-2 fw-bold text-primary">Loading PO...</p>
      </div>
    ) : (
      <>
        <POMakingModal
          items={selectedItem}
          show={gridInsideModal}
          test={setTest}
          handleClose={() => setGridInsideModal(false)}
        />

        <div className="row">
          <div className="col-xl-12">
            {/* Filter box */}
            <div className="filter cm-content-box box-primary">
              <div className="content-title">
                <div className="cpa">
                  <i className="fas fa-filter me-2"></i>Filter
                </div>
                <div className="tools">
                  <Link to="#" className={`SlideToolHeader ${open ? 'collapse' : 'expand'}`} onClick={() => setOpen(!open)}>
                    <i className="fas fa-angle-up"></i>
                  </Link>
                </div>
              </div>
              <Collapse in={open}>
                <div className="cm-content-body form excerpt">
                  <div className="card-body">
                    <div className="row">
                      <div className="col-xl-3 col-xxl-6">
                        <input
                          type="text"
                          className="form-control mb-xl-0 mb-3"
                          placeholder="Search by Repair Order No, Store"
                          value={searchTerm}
                          onChange={(e) => setSearchTerm(e.target.value)}
                        />

                      </div>
                      <div className="col-xl-3 col-xxl-6">
                        <Select
                          placeholder="Rows per page"
                          value={options.find(option => option.value === sort)}
                          onChange={(selectedOption) => setSort(Number(selectedOption.value))}
                          isSearchable={false}
                          options={options}
                          className="custom-react-select mb-3 mb-xxl-0"
                        />
                      </div>
                    </div>
                  </div>
                </div>
              </Collapse>
            </div>

            {/* Data Table */}
            <div className="filter cm-content-box box-primary">
              <div className="content-title d-flex justify-content-between align-items-center">
                {/* Left side: Title */}
                <div className="cpa">
                  <i className="fa fa-list me-2" aria-hidden="true"></i>
                  Pending PO <span className="badge bg-orange ms-2">{filteredSearch.length}</span>
                </div>

                {/* Right side: Download + Collapse Tools */}
                <div className="d-flex align-items-center gap-2">
                  <button
                    className="btn btn-sm btn-primary"
                    onClick={handleDownloadExcel}
                  >
                    <i className="fa fa-download me-1"></i>Download Excel
                  </button>

                  <div className="tools">
                    <Link
                      to="#"
                      className={`SlideToolHeader ${open2 ? "collapse" : "expand"}`}
                      onClick={() => setOpen2(!open2)}
                    >
                      <i className="fas fa-angle-up"></i>
                    </Link>
                  </div>
                </div>
              </div>

              <Collapse in={open2}>
                <div className="cm-content-body form excerpt">
                  <div className="card-body">
                    <div className="table-responsive">
                      <div id="content_wrapper" className="dataTables_wrapper no-footer">
                        <table className="table table-bordered table-responsive-lg table-striped table-condensed flip-content" id="active-users-data">
                          <thead>
                            <tr>
                              <th>S.No</th>
                              <th>Store</th>
                              <th>Request No.</th>
                              <th>Created Date</th>
                              <th>Approved Date</th>
                              <th>Item Count</th>
                              <th>Actions</th>
                            </tr>
                          </thead>
                          <tbody>
                            {filteredSearch.length > 0 ? (
                              filteredSearch
                                .slice(activePag.current * sort, (activePag.current + 1) * sort)
                                .map((row, index) => (
                                  <tr key={index}>
                                    <td>{activePag.current * sort + index + 1}</td>

                                    <td>{row?.store}</td>
                                    <td>{row?.repairOrderNo}</td>
                                    <td>
                                      {row?.items?.[0]?.createdAt
                                        ? new Date(row.items[0].createdAt).toLocaleString("en-GB", {
                                          day: "2-digit",
                                          month: "2-digit",
                                          year: "numeric",
                                          hour: "2-digit",
                                          minute: "2-digit",
                                          second: "2-digit",
                                        })
                                        : "N/A"}
                                    </td>

                                    <td>
                                      {row?.items?.[0]?.updatedAt
                                        ? new Date(row.items[0].updatedAt).toLocaleString("en-GB", {
                                          day: "2-digit",
                                          month: "2-digit",
                                          year: "numeric",
                                          hour: "2-digit",
                                          minute: "2-digit",
                                          second: "2-digit",
                                        })
                                        : "N/A"}
                                    </td>

                                    <td>{row?.itemCount}</td>
                                    <td>
                                      <button
                                        className="btn btn-primary btn-xs"
                                        onClick={() => handleViewClick(row)}
                                      >
                                        View Items/Generate PO
                                      </button>
                                    </td>
                                  </tr>
                                ))
                            ) : (
                              <tr>
                                <td colSpan="7" className="text-center">No Pending PO Records Found</td>
                              </tr>
                            )}
                          </tbody>
                        </table>

                        {/* Pagination */}
                        <div className="d-sm-flex text-center justify-content-between align-items-center mt-3">
                          <div className="dataTables_info">
                            Showing {filteredSearch.length > 0 ? (activePag.current * sort + 1) : 0} to{" "}
                            {Math.min(filteredSearch.length, (activePag.current + 1) * sort)}{" "}
                            of {filteredSearch.length} entries
                          </div>
                          <div className="dataTables_paginate paging_simple_numbers">
                            <Link className="paginate_button previous" to="#" onClick={() => activePag.current > 0 && onClick(activePag.current - 1)}>
                              <i className="fa fa-angle-double-left" aria-hidden="true"></i>
                            </Link>
                            <span>
                              {Array.from({ length: pagination }, (_, i) => (
                                <Link
                                  key={i}
                                  to="#"
                                  className={`paginate_button ${activePag.current === i ? "current" : ""}`}
                                  onClick={() => onClick(i)}
                                >
                                  {i + 1}
                                </Link>
                              ))}
                            </span>
                            <Link className="paginate_button next" to="#" onClick={() => activePag.current < pagination - 1 && onClick(activePag.current + 1)}>
                              <i className="fa fa-angle-double-right" aria-hidden="true"></i>
                            </Link>
                          </div>
                        </div>

                      </div>
                    </div>
                  </div>
                </div>
              </Collapse>
            </div>
          </div>
        </div>
      </>
    )
  )
};

export default PoPendingList;
